module.exports = __webpack_public_path__ + "media/images/avatar/development/nannies/9-80304b5a573e03866fdefdc71ce4048e.jpg";